module.exports = __webpack_public_path__ + "static/scale-model-of-worldwide-pilgrimage-in-jacksonville-florida-7f0b07cbfdb13c86595a0c6cb7b3a3ee.png";